<template lang="pug">
    .animation(ref='animation')
        span.bottle
            img(src='../../assets/img/animations/bottle.svg')
        span.cork(ref='cork')
            img(src='../../assets/img/animations/cork.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'top-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline.fromTo(this.$refs.cork, {x: 0}, {duration: 3, x: '1000', y: '-1000'}, 0);
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    position: relative;
    width: fit-content;
    @media (--viewport-tablet) {
        margin: auto;
    }
}
.cork {
    position: absolute;
    top: 0;
    left: 0;
}
</style>
